import {
  FormControlLabel,
  Checkbox,
  TextField,
  Box,
  Card,
  Button,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import { blobUrl } from '../Constants';
import { ArtistMedia } from '../@types/api';

interface Props {
  audio: ArtistMedia;
  onSaveAudio: (video: ArtistMedia) => void;
  onRemoveAudio: (video: ArtistMedia) => void;
  isSelected: boolean;
}
const YouTubeVideoCard: React.FC<Props> = ({
  audio,
  onSaveAudio,
  onRemoveAudio,
  isSelected,
}) => {
  const [orderIndex, setOrderIndex] = useState<number>(audio.orderIndex);
  const [isLive, setIsLive] = useState<boolean>(audio.isLive);
  const [shouldDelete, setShouldDelete] = useState<boolean>(false);
  const isDirty =
    shouldDelete || orderIndex !== audio.orderIndex || isLive !== audio.isLive;

  const handleSave = () => {
    const updatedAudio = {
      ...audio,
      isLive,
      orderIndex,
    };
    onSaveAudio(updatedAudio);
  };

  const handleDelete = () => {
    onRemoveAudio(audio);
  };

  const handleReset = () => {
    setIsLive(audio.isLive);
    setOrderIndex(audio.orderIndex);
    setShouldDelete(false);
  };

  return (
    <>
      <Card raised={isSelected}>
        <Box px={1}>
          <Typography variant='subtitle2' p={2}>
            {audio.upload?.altText}
          </Typography>
          <audio controls style={{ maxWidth: '100%' }}>
            <source
              src={`${blobUrl}/mp3s/${audio.upload?.fileName}`}
              type='audio/mpeg'
            />
          </audio>
        </Box>

        <Box
          justifyContent='space-between'
          display='flex'
          alignItems='center'
          sx={{ width: '100%', p: 1 }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={isLive}
                onChange={() => setIsLive(!isLive)}
                disabled={!isSelected}
              />
            }
            label='Live'
          />
          <TextField
            label='Order'
            disabled={!isSelected}
            type='number'
            variant='outlined'
            value={orderIndex}
            onChange={(e) => setOrderIndex(Number(e.currentTarget.value))}
            InputProps={{ inputProps: { min: 0 } }}
            size='small'
            sx={{ maxWidth: 60 }}
          />
        </Box>

        <Box
          justifyContent='space-between'
          display='flex'
          alignItems='center'
          sx={{ width: '100%' }}
        >
          <Button
            aria-label='cancel'
            onClick={handleReset}
            disabled={!isDirty}
            title='cancel'
            startIcon={
              <CancelIcon color={isDirty ? 'secondary' : 'disabled'} />
            }
          >
            Undo
          </Button>
          <Button
            aria-label='delete'
            onClick={handleDelete}
            title='delete'
            startIcon={<DeleteIcon color={'warning'} />}
          >
            Delete
          </Button>
          {isDirty && <WarningIcon color='warning' />}
          <Button
            aria-label='save'
            onClick={handleSave}
            title='save changes'
            startIcon={<SaveIcon color={isDirty ? 'action' : 'disabled'} />}
          >
            Save
          </Button>
        </Box>
      </Card>
    </>
  );
};

export default YouTubeVideoCard;
